// Faixa de alarme da plataforma (hoje: broker MQTT fora), só para o admin. Fica no topo de
// todas as telas enquanto o alarme estiver aberto — a falha de 17/10/2026 passou 13 dias
// visível apenas a quem abrisse o Diagnóstico. Quem abre e fecha é o monitor da API.

import { useQuery } from "@tanstack/react-query";
import { OctagonAlert } from "lucide-react";
import { Link } from "react-router";
import { api } from "../lib/api";

export interface PlatformAlert {
  id: number;
  kind: string;
  summary: string;
  raised_at: string;
  cleared_at: string | null;
}

export interface PlatformAlerts {
  active: PlatformAlert[];
  recent: PlatformAlert[];
}

export const ALERT_TITLE: Record<string, string> = {
  broker_down: "Broker MQTT fora: a plataforma não está recebendo dados dos gateways",
};

export const usePlatformAlerts = (enabled: boolean) =>
  useQuery({
    queryKey: ["platform-alerts"],
    queryFn: () => api.get<PlatformAlerts>("/api/admin/alerts"),
    enabled,
    refetchInterval: 60_000,
  });

export function PlatformAlertBanner({ enabled }: { enabled: boolean }) {
  const { data } = usePlatformAlerts(enabled);
  if (!enabled || !data?.active.length) return null;
  return (
    <div role="alert" className="border-b border-danger/40 bg-danger/10 px-4 py-2 text-sm text-danger">
      {data.active.map((a) => (
        <p key={a.id} className="mx-auto flex max-w-6xl flex-wrap items-center gap-x-2 gap-y-0.5">
          <OctagonAlert className="size-4 shrink-0" aria-hidden />
          <span className="font-medium">{ALERT_TITLE[a.kind] ?? a.kind}</span>
          <span className="text-danger/80">desde {new Date(a.raised_at).toLocaleString("pt-BR")}</span>
          <Link to="/admin/diagnostico" className="ml-auto underline underline-offset-2">
            Ver diagnóstico
          </Link>
        </p>
      ))}
    </div>
  );
}
